'use strict';

import React from 'external/react';
import PropTypes from 'external/prop-types';
import '../css/item-description.scss';

const ItemDescription = ({ item }) => {

    const { description } = item;

    return (
        <React.Fragment>
            {description && <span className="item-description" dangerouslySetInnerHTML={{ __html: description }}/>}
            {!description && '---'}
        </React.Fragment>
    );
};

ItemDescription.propTypes = {
    item: PropTypes.object.isRequired
};

export default ItemDescription;



// WEBPACK FOOTER //
// ./js/components/ItemDescription.jsx